import React from 'react';
import { Icon } from 'semantic-ui-react';
import globalStyles from '../../styles/globalStyles';

/**
 * 聊天页面容器
 * 内嵌 iframe 展示聊天应用
 * 修改时间：2026-06-12
 */
const Chat = () => {
  const chatLink = localStorage.getItem('chat_link');

  if (!chatLink) {
    return (
      <div style={globalStyles.page}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}>
          <div style={{
            textAlign: 'center',
            padding: 40,
            background: 'rgba(0,0,0,0.02)',
            borderRadius: 16,
            border: '1px solid rgba(0,0,0,0.08)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
          }}>
            <Icon name='comments outline' style={{ fontSize: 48, color: '#18181b', marginBottom: 16 }} />
            <p style={{ color: '#6b7280', fontSize: 16, margin: 0 }}>暂未配置聊天地址</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      borderRadius: 16,
      overflow: 'hidden',
      boxShadow: '0 18px 45px rgba(0,0,0,0.06)',
      border: '1px solid rgba(0,0,0,0.08)',
    }}>
      <iframe
        src={chatLink}
        style={{ width: '100%', height: '85vh', border: 'none' }}
        title='chat'
      />
    </div>
  );
};

export default Chat;
